<template>
  <div class="layout">
    <!-- 导航栏 -->
    <nav class="navbar">
      <!-- <div class="user-info">
        <span v-if="currentUser && currentUser.positionId && !isAdmin" class="position-id">
          欢迎ID: <span v-if="currentUser.positionName">{{ currentUser.positionName }}</span>{{ currentUser.positionId }}
        </span>
        <span v-else-if="currentUser">欢迎，{{ currentUser.username }}</span>
        <span v-else>加载中...</span>
      </div> -->
      <div class="nav-buttons">
        <router-link :to="item.path" class="nav-link" active-class="active" v-for="(item, index) in routerArr"
          :key="index">{{ item.title }}</router-link>
      </div>
    </nav>

    <!-- 内容区域 -->
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getEnumValuesRouterArr } from '@/utils/jdApi'
export default {
  name: 'AppLayout',
  data() {
    return {
      routerArr: [
        {
          path: '/promotion',
          title: '转链',
          isAdminOnly: true,
          isShow: true
        }, {
          path: '/order-query',
          title: '订单',
          isAdminOnly: false,
          isShow: true
        },
        {
          path: '/guide',
          title: '攻略',
          isAdminOnly: false,
          isShow: true
        },
        {
          path: '/products',
          title: '商品',
          isAdminOnly: false,
          isShow: true
        },
        // {
        //   path: '/product-list',
        //   title: '大促',
        //   isAdminOnly: false,
        //   isShow: false
        // }, 
        {
          path: '/goods-list',
          title: '热销',
          isAdminOnly: false,
          isShow: true
        }, {
          path: '/mypage',
          title: '我的',
          isAdminOnly: false,
          isShow: true
        }
      ],
      // routerArr: []
    }
  },
  computed: {
    // 检查是否为管理员
    isAdmin() {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return user.role === 'ADMIN'
    },
  },
  activated() {
    // this.getRouterArr()
  },
  methods: {
    getRouterArr() {
      this.routerArr = []
      getEnumValuesRouterArr().then(res => {
        if (res && res.success) {
          const list = JSON.parse(res.data.routerArr) || []
          list.map(item => {
            if (item.isShow) {
              if (!item.isAdminOnly || (item.isAdminOnly && this.isAdmin)) {
                this.routerArr.push(item)
              }
            }
          })
        } else {
          return this.$message.error('无法从枚举表加载，请先配置枚举值')
        }
      })
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #f5f5f5;
}

.navbar {
  background: #42b983;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.nav-link {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
  flex: 1;
  text-align: center;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.3);
  text-decoration: none;
  color: white;
}

.nav-link.active {
  background: white;
  color: #42b983;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}

.position-id {
  font-size: 12px;
  opacity: 0.8;
}


.content {
  flex: 1;
  /* 让页面在navbar下方滚动，navbar保持吸顶 */
  overflow: auto;
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .layout {
    width: 760px;
    margin: 0 auto;
  }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .navbar {
    padding: 10px 12px;
    gap: 8px;
  }

  .nav-buttons {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .nav-link {
    padding: 6px 10px;
    font-size: 12px;
    white-space: nowrap;
  }

  .user-info {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    gap: 8px;
  }

  .position-id {
    font-size: 11px;
  }

  .logout-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
}
</style>
